import * as R from 'ramda'
import * as recompose from 'recompose'
import { connect } from 'react-redux'

import * as configuration from '../../../configuration'
import { clientTypes } from '../../../client-type'

import { LiveCasinoQuery as Component } from './live-casino-query'

function mapStateToProps(state) {
  return {
    liveCasinoChannel: configuration.getLiveCasinoChannel(state.configuration),
    clientType: configuration.getClientType(state.configuration),
  }
}

export const LiveCasinoQuery = R.compose(
  connect(mapStateToProps),
  recompose.branch(
    props => R.equals(props.clientType, clientTypes.UNKNOWN),
    recompose.renderNothing
  )
)(Component)
